import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';
import { useQuery } from '@tanstack/react-query';
import { CacheConfig } from './consts';

const TERMINATE_REASONS_PATH = '/api/TerminateReasons';

export const getTerminateReasonsSearchProps = () => makeRequest(authFetch.get(`${TERMINATE_REASONS_PATH}/SearchProperties`));

const getTerminateReasonsUrl = (params) => `${TERMINATE_REASONS_PATH}${getQueryParams(params)}`;
export const getTerminateReasons = (params) => makeRequest(authFetch.get(getTerminateReasonsUrl(params)));
export const getAllTerminateReasons = () => makeRequest(authFetch.get(getTerminateReasonsUrl({ pageSize: 9999, page: 1 })).then(({ data }) => data));
export const useGetAllTerminateReasons = (opts = {}) => useQuery(
  ['allTerminateReasons'], getAllTerminateReasons, { ...CacheConfig.forever, ...opts },
);

export const getTerminateReason = (id) => makeRequest(authFetch.get(`${TERMINATE_REASONS_PATH}/${id}`));
export const putTerminateReason = (data) => makeRequest(authFetch.put(TERMINATE_REASONS_PATH, data));

export const deleteTerminateReason = (id) => makeRequest(authFetch.delete(`${TERMINATE_REASONS_PATH}/${id}`));
export const restoreTerminateReason = (id) => makeRequest(authFetch.patch(`${TERMINATE_REASONS_PATH}/${id}/restore`));

// Audit
export const getTerminateReasonAudits = (id, params) => makeRequest(authFetch.get(`${TERMINATE_REASONS_PATH}/${id}/Audits${getQueryParams(params)}`));
export const getTerminateReasonAuditProperties = (id) => makeRequest(authFetch.get(`${TERMINATE_REASONS_PATH}/${id}/Audits/Properties`));
export const getTerminateReasonAuditUsers = (id) => makeRequest(authFetch.get(`${TERMINATE_REASONS_PATH}/${id}/Audits/Users`));
